import Vue from "vue";
import Router from "vue-router";
import index from "../pages/Index";

//home
import homeComponent from "../pages/home";
import productComponent from "../pages/product";

Vue.use(Router);

const router = new Router({
  // mode: "history",
  // base: "/v9source/",
  routes: [
    {
      path: "/",
      redirect: "/home",
      component: index,
      children: [
        {
          path: "/product",
          name: "product",
          redirect: "/product/systemsix",
          component: () => import("../pages/product"),
          meta: {
            title: "产品中心"
          }
        },
        {
          path: "/product/systemone",
          name: "productsystemone",
          component: () => import("../pages/product/systenone.vue"),
          meta: {
            title: "业务经办服务智能内控系统"
          }
        },
        ,
        {
          path: "/product/systemtwo",
          name: "productsystemtwo",
          component: () => import("../pages/product/systemtwo.vue"),
          meta: {
            title: "医保智能审核系统"
          }
        },
        ,
        {
          path: "/product/systemfive",
          name: "productsystemfive",
          component: () => import("../pages/product/systemfive.vue"),
          meta: {
            title: "医保基金监管综合执法平台"
          }
        },
        {
          path: "/product/systemsix",
          name: "productsysystemsix",
          component: () => import("../pages/product/systemsix.vue"),
          meta: {
            title: "人社云精准扶弱管理系统"
          }
        },
        {
          path: "/product/systemseven",
          name: "productsystemseven",
          component: () => import("../pages/product/systemseven.vue"),
          meta: {
            title: "人社云大数据智能分析平台"
          }
        },
        {
          path: "/product/systemeight",
          name: "productsysystemeight",
          component: () => import("../pages/product/systemeight.vue"),
          meta: {
            title: "人社云数据可视化分析平台"
          }
        },
        {
          path: "/product/systemthree",
          name: "productsystemthree",
          component: () => import("../pages/product/systemthree.vue"),
          meta: {
            title: "医保基金运行分析监测系统"
          }
        },
        {
          path: "/product/systemfour",
          name: "productsystemfour",
          component: () => import("../pages/product/systemfour.vue"),
          meta: {
            title: "医保基金画像分析系统"
          }
        },
        {
          path: "/plan",
          name: "plan",
          redirect: "/plan/planone",
          component: () => import("../pages/plan/one.vue"),
          meta: {
            title: "解决方案"
          }
        },
        {
          path: "/plan/planone",
          name: "planone",
          component: () => import("../pages/plan/one.vue"),
          meta: {
            title: "人社云解决方案"
          }
        },
        {
          path: "/plan/plantwo",
          name: "plantwo",
          component: () => import("../pages/plan/two.vue"),
          meta: {
            title: "医保云解决方案"
          }
        },
        {
          path: "/plan/planthree",
          name: "planthree",
          component: () => import("../pages/plan/three.vue"),
          meta: {
            title: "商保云解决方案"
          }
        }
      ]
    },
    {
      path: "/home",
      name: "home",
      component: homeComponent,
      meta: {
        title: "首页"
      }
    },
    {
      path: "/pcuser",
      name: "pcuser",
      component: () => import("../pages/about/index.vue"),
      meta: {
        title: "关于我们"
      }
    }
  ]
});
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
//路由开始之前的操作
// console.log(router);
// router.beforeEach((to, from, next) => {
//   // let toName = to.name;
//   let is_login = JSON.stringify(cookieStorage.get('user_status')) == '{}'? false: true;
//   if (to.matched.some(record => record.meta.requireAuth)){ // 判断该路由是否需要登录权限
//     if (is_login) { // 判断当前的token是否存在
//       next();
//     } else {
//       next({
//         path: '/login',

//       })
//     }
//   }
//   else {
//     next();
//   }
// });
// if (!is_login && toName !== 'history') {
//   next({
//     name: 'login'
//   })
// }else {
//   if (is_login && toName === 'login') {
//     next({
//       path: '/'
//     })
//   } else {
//     next()
//   }
// }
// });
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js